import { render, staticRenderFns } from "./ChaletRecommendation.vue?vue&type=template&id=252856c4"
import script from "./ChaletRecommendation.vue?vue&type=script&lang=js"
export * from "./ChaletRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports